/* eslint-disable react/jsx-no-target-blank */
import { useEffect, useState } from "react";
import { ADD_PROPERTY_URL, PROPERTIES_URL } from "../../global/API";
import { Icon } from "@iconify/react";
import PropertyList from "../../components/propertyList/propertyList";
import PropertyGrid from "../../components/propertyGrid/propertyGrid";
import FilterForm from "../../components/filterForm/filterForm";
import AddLead from "../../components/addLead/addlead";
import Pagination from "rc-pagination";
import Cookies from "js-cookie";
import "./propertyListing.css";
import { FileUpload } from "primereact/fileupload";
import { IconInput, NumberInput, RadioGroup, SelectInput, TextInput } from "../../components/formElements/formElements";
import CustomModal from "../../components/customModal/customModal";
import { useLocation, useNavigate } from "react-router-dom";

const textInputFields = [
  { id: "Apn", label: "Apn" },
  { id: "Stories", label: "Stories" },
  { id: "RoomType", label: "Room Type" },
  { id: "HalfBaths", label: "Half Baths" },
  { id: "FullBaths", label: "Full Baths" },
  { id: "CurrentUse", label: "Current Use" },
  { id: "Foundation", label: "Foundation" },
  { id: "Possession", label: "Possession" },
  { id: "UpperLevel", label: "Upper Level" },
  { id: "BathFeatures", label: "Bath Features", col: 6 },
  { id: "KitchenFeatures", label: "Kitchen Features", col: 6 },
  { id: "ParkingFeatures", label: "Parking Features" },
  { id: "LaundryFeatures", label: "Laundry Features" },
  { id: "PoolFeatures", label: "Pool Features" },
  { id: "DiningFeatures", label: "Dining Room Features" },
  { id: "MasterBathroomFeatures", label: "Master Bathroom Features" },
  { id: "HorsePropertyFeatures", label: "Horse Property Features" },
  { id: "Roof", label: "Roof" },
  { id: "Flooring", label: "Flooring" },
  { id: "Utilities", label: "Utilities" },
  { id: "Appliances", label: "Appliances" },
  { id: "Cooling", label: "Cooling" },
  { id: "Fencing", label: "Fencing" },
  { id: "WaterSource", label: "Water Source" },
];

const radioGroups = [
  { name: "pool", label: "Pool" },
  { name: "association", label: "Association" },
  { name: "HorseProperty", label: "Horse Property" },
  { name: "spa", label: "Spa" },
  { name: "auction", label: "Auction" },
];

const PropertyListing = () => {
  const [properties, setProperties] = useState([]);
  const [paginationObj, setPaginationObj] = useState({
    pageSize: 35,
    current: 1,
  });

  const [filteredValues, setFilteredValues] = useState({
    minPrice: "",
    maxPrice: "",
    bedrooms: "0",
    bathrooms: "0",
    propStatus: "",
    propType: "",
    searchValue: "",
  });

  const [isLoading, setIsLoading] = useState(true);
  const [propertyView, setPropertyView] = useState("List");
  const [resetCount, setResetCount] = useState(0);
  const [selectedListings, setSelectedListings] = useState([]);
  const [modifiedPropertyDetails, setModifiedPropertyDetails] = useState({});

  const onHandleselectedList = (listingID, userAgentID, event) => {
    const newList = { listingID, userAgentID };
    if (event.target.checked) {
      setSelectedListings((preState) => [...preState, newList]);
    } else {
      const filteredListing = selectedListings.filter((item) => item.listingID !== listingID);
      setSelectedListings(filteredListing);
    }
  };

  // const onHandleEvent = (event, setFunction) => {
  //   const { name, value } = event.target;
  //   setFunction((previousState) => ({ ...previousState, [name]: value }));
  // };
  const onHandleEvent = (e, setState) => {
    const { name, value, type, checked, multiple, options } = e.target;

    let newValue;
    if (type === "checkbox") newValue = checked;
    else if (multiple) {
      // collect selected values for <select multiple>
      newValue = Array.from(options)
        .filter((o) => o.selected)
        .map((o) => o.value);
    } else newValue = value;

    setState((prev) => ({ ...prev, [name]: newValue }));
  };

  const fetchData = async (current, pageSize = paginationObj.pageSize) => {
    const { minPrice, maxPrice, bedrooms, bathrooms, propStatus, propType, searchValue } = filteredValues;
    setIsLoading(true);
    const jwtToken = Cookies.get("jwtToken");
    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}` },
    };
    const URL =
      PROPERTIES_URL +
      `?limit=${pageSize}&page=${current}&minPrice=${minPrice}&maxPrice=${maxPrice}&minBeds=${bedrooms}&minBaths=${bathrooms}&propStatus=${propStatus}&propType=${propType}&search=${searchValue}`;
    try {
      const response = await fetch(URL, options);
      if (response.ok) {
        const data = await response.json();
        setProperties(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData(paginationObj.current, paginationObj.pageSize);
  }, []);

  useEffect(() => {
    const { searchValue } = filteredValues;
    // console.log(searchValue);
    if (searchValue.length >= 3 || searchValue === "") {
      const timeout = setTimeout(() => {
        fetchData(1, paginationObj.pageSize);
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [filteredValues.searchValue]);

  useEffect(() => {
    if (resetCount > 0) {
      fetchData(1);
    }
  }, [resetCount]);

  const paginationChange = (current, pageSize) => {
    setPaginationObj({ ...paginationObj, current });
    fetchData(current, pageSize);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const filterGrid = (e) => {
    const { name, value } = e.target;
    setFilteredValues({
      ...filteredValues,
      [name]: value,
    });
  };

  const onFilterSubmit = () => {
    fetchData(1, paginationObj.pageSize);
  };

  const onToogleMenu = () => {
    const element = document.getElementById("listBoxes");
    element.classList.toggle("listBoxes-active");
  };

  const onHandleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    for (const key in modifiedPropertyDetails) {
      formData.append(key, modifiedPropertyDetails[key]);
    }

    try {
      const jwtToken = Cookies.get("jwtToken");
      const options = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          Accept: "application/json",
        },
      };

      const response = await fetch(ADD_PROPERTY_URL + "0", options);
      const data = await response.json();

      if (data.status === "Success") {
        setSelectedListings([]);
        fetchData(paginationObj.current, paginationObj.pageSize);
        navigate(`/properties`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const renderItem = () => {
    return (
      <form onSubmit={onHandleSubmit}>
        <div className="add-property-form">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Add Property Photo</h4>
            </div>
            <div className="card-body mb-3">
              <FileUpload
                url={"https://realtyapp.realtyitsolutions.com/api/"}
                multiple
                auto
                accept="image/*"
                maxFileSize={10000000}
                onUploadedFiles={(uploaded) => {
                  // uploaded: [{name, url, raw}, ...]
                  setModifiedPropertyDetails((prev) => ({ ...prev, photos: uploaded }));
                }}
                emptyTemplate={
                  <div className="dz-message">
                    <i className="ri-upload-cloud-2-line fs-48 text-primary"></i>
                    <h3 className="">Drop your images here</h3>
                    <span className="text-muted fs-13">1600 x 1200 (4:3) recommended. PNG, JPG and GIF files are allowed</span>
                  </div>
                }
              />
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Property Information</h4>
            </div>
            <div className="card-body">
              <div className="row">
                {/* <div className="col-12 col-lg-4 mb-3">
                  <NumberInput
                    id="listingID"
                    label="Listing ID"
                    name="listingID"
                    value={modifiedPropertyDetails.listingID}
                    onChange={(e) => {
                      onHandleEvent(e, setModifiedPropertyDetails);
                    }}
                    placeholder="Listing ID"
                  />
                </div> */}
                <div className="col-lg-8 mb-3">
                  <TextInput
                    id="PropertyAddress"
                    label="Property Address"
                    name="address"
                    value={modifiedPropertyDetails.address}
                    onChange={(e) => {
                      onHandleEvent(e, setModifiedPropertyDetails);
                    }}
                    placeholder="Enter Property Address"
                  />
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <TextInput
                    id="county"
                    label="County"
                    placeholder="County"
                    name="countyName"
                    value={modifiedPropertyDetails.countyName}
                    onChange={(e) => {
                      onHandleEvent(e, setModifiedPropertyDetails);
                    }}
                  />
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <TextInput
                    id="state"
                    label="State"
                    placeholder="State"
                    name="state"
                    value={modifiedPropertyDetails.state}
                    onChange={(e) => {
                      onHandleEvent(e, setModifiedPropertyDetails);
                    }}
                  />
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <TextInput
                    id="city"
                    label="City"
                    placeholder="City"
                    name="cityName"
                    value={modifiedPropertyDetails.cityName}
                    onChange={(e) => {
                      onHandleEvent(e, setModifiedPropertyDetails);
                    }}
                  />
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <TextInput
                    id="Zip-Code"
                    label="Zip-Code"
                    placeholder=""
                    name="zipcode"
                    value={modifiedPropertyDetails.zipcode}
                    onChange={(e) => {
                      onHandleEvent(e, setModifiedPropertyDetails);
                    }}
                  />
                </div>
                {/* <div className="col-12 col-lg-4 mb-3">
                  <TextInput id="propertyName" label="Property Name" name="" placeholder="Property Name" />
                </div> */}
                <div className="col-12 col-lg-4 mb-3">
                  <SelectInput
                    id="property-categories"
                    label="Property Categories"
                    name="idxPropType"
                    value={modifiedPropertyDetails.idxPropType}
                    onChange={(e) => {
                      onHandleEvent(e, setModifiedPropertyDetails);
                    }}
                    options={[
                      { value: "Villas", label: "Villas" },
                      { value: "Residences", label: "Residences" },
                      { value: "Bungalow", label: "Bungalow" },
                      { value: "Apartment", label: "Apartment" },
                      { value: "Penthouse", label: "Penthouse" },
                    ]}
                  />
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <SelectInput
                    id="property-status"
                    label="Property Status"
                    name="propStatus"
                    value={modifiedPropertyDetails.propStatus}
                    onChange={(e) => {
                      onHandleEvent(e, setModifiedPropertyDetails);
                    }}
                    options={[
                      { value: "Active", label: "Active" },
                      { value: "Contingent - Show", label: "Contingent - Show" },
                    ]}
                  />
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <label htmlFor="property-price" className="form-label">
                    Price
                  </label>
                  <div className="input-group">
                    <span className="input-group-text fs-20 py-0">
                      <i className="ri-money-dollar-circle-line"></i>
                    </span>
                    <input
                      type="text"
                      id="property-price"
                      className="form-control"
                      placeholder="000"
                      name="listingPrice"
                      value={modifiedPropertyDetails.listingPrice}
                      onChange={(e) => {
                        onHandleEvent(e, setModifiedPropertyDetails);
                      }}
                    />
                  </div>
                </div>
                {/* <div className="col-12 col-lg-4 mb-3">
                  <label htmlFor="property-for" className="form-label">
                    Property For
                  </label>
                  <select className="form-control" id="property-for" data-choices data-choices-groups data-placeholder="Select Categories" name="choices-single-groups">
                    <option value="Sale">Sale</option>
                    <option value="Rent">Rent</option>
                    <option value="Other">Other</option>
                  </select>
                </div> */}
                <div className="col-12 col-lg-4 mb-3">
                  <IconInput
                    id="property-square-foot"
                    label="Square Foot"
                    icon="scale-broken"
                    name="sqFt"
                    value={modifiedPropertyDetails.sqFt}
                    onChange={(e) => {
                      onHandleEvent(e, setModifiedPropertyDetails);
                    }}
                  />
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <IconInput
                    id="bedroom"
                    label="Bedroom"
                    icon="bath-broken"
                    name="bedrooms"
                    value={modifiedPropertyDetails.bedrooms}
                    onChange={(e) => {
                      onHandleEvent(e, setModifiedPropertyDetails);
                    }}
                  />
                </div>
                <div className="col-12 col-lg-4 mb-3">
                  <IconInput
                    id="bathroom"
                    label="Bathroom"
                    icon="bath-broken"
                    name="totalBaths"
                    value={modifiedPropertyDetails.totalBaths}
                    onChange={(e) => {
                      onHandleEvent(e, setModifiedPropertyDetails);
                    }}
                  />
                </div>
                {/* <div className="col-12 col-lg-4 mb-3">
                  <IconInput id="floor" label="Floor" icon="double-alt-arrow-up-broken" placeholder="" />
                </div> */}

                <div className="col-lg-12 mb-3">
                  <label htmlFor="property-description" className="form-label">
                    Property Description
                  </label>
                  <textarea
                    className="form-control"
                    id="property-description"
                    rows="5"
                    name="remarksConcat"
                    value={modifiedPropertyDetails.remarksConcat}
                    onChange={(e) => {
                      onHandleEvent(e, setModifiedPropertyDetails);
                    }}
                  ></textarea>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Property Features / Amenities</h4>
            </div>
            <div className="card-body">
              <div className="row mb-3">
                {radioGroups.map(({ name, label }) => (
                  <div className="col-6 col-lg-2 mb-3" key={name}>
                    <RadioGroup
                      name={name}
                      onChange={(e) => {
                        onHandleEvent(e, setModifiedPropertyDetails);
                      }}
                    >
                      {label}
                    </RadioGroup>
                  </div>
                ))}
                {/* {textInputFields.map(({ id, label, col = 4 }) => (
                  <div className={`col-12 col-lg-${col} mb-3`} key={id}>
                    <TextInput id={id} label={label} placeholder="" />
                  </div>
                ))} */}
              </div>
              <div className="row justify-content-end g-2">
                <div className="col-6 col-lg-2">
                  <button type="submit" className="btn btn-outline-primary w-100">
                    Create Property
                  </button>
                </div>
                <div className="col-6 col-lg-2">
                  <button type="button" className="btn btn-danger w-100" data-bs-dismiss="modal" aria-label="Close">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  };

  return (
    <div className="page-content property-listings">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Property Listings</h4>
              <button type="button" title="Hide Boxes" className="listCardHamburger" onClick={onToogleMenu}>
                <i className="ri-expand-up-down-line"></i>
              </button>
              <div className="page-title-box-content">
                <button type="button" className="btn add-btn" data-bs-toggle="modal" data-bs-target="#addLead" disabled={selectedListings.length !== 1}>
                  Add Lead
                </button>
                <button
                  type="button"
                  className="btn add-btn"
                  onClick={() => {
                    navigate("new-property");
                  }}
                >
                  Add Property
                </button>
                <button
                  type="button"
                  className="refresh-button"
                  title="Reset"
                  onClick={() => {
                    setFilteredValues({
                      minPrice: "",
                      maxPrice: "",
                      bedrooms: "0",
                      bathrooms: "0",
                      propStatus: "",
                      propType: "",
                      searchValue: "",
                    });
                    setResetCount(resetCount + 1);
                  }}
                >
                  <i className="ri-refresh-line"></i>
                </button>
                <button type="button" className="filter-button" id="page-header-user-dropdown" data-bs-toggle="modal" data-bs-target="#filterModal">
                  <i className="ri-filter-2-line"></i>
                </button>
                <form className="app-search">
                  <div className="position-relative">
                    <input
                      type="search"
                      className="form-control border-0"
                      placeholder="Location Search..."
                      autoComplete="off"
                      value={filteredValues.searchValue}
                      onChange={filterGrid}
                      name="searchValue"
                    />
                    <i className="ri-search-line search-widget-icon"></i>
                  </div>
                </form>
                <div className="grid-view">
                  <button
                    type="button"
                    onClick={() => {
                      setPropertyView("List");
                    }}
                    className={propertyView === "List" ? "bx bx-menu active" : "bx bx-menu"}
                  ></button>
                  <button
                    type="button"
                    onClick={() => {
                      setPropertyView("Grid");
                    }}
                    className={propertyView === "Grid" ? "bx bxs-grid active" : "bx bxs-grid"}
                  ></button>
                </div>
              </div>

              {/* <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">Real Estate</li>
                <li className="breadcrumb-item active">Property Listing</li>
              </ol> */}
              <div className="modal fade filter-model" id="filterModal" aria-labelledby="filterModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h1 className="modal-title fs-5" id="filterModalLabel">
                        Properties Filter
                      </h1>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                      <FilterForm filterGrid={filterGrid} onFilterSubmit={onFilterSubmit} filteredValues={filteredValues} propertyView={propertyView} isPopup={true} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="listBoxes" className="listBoxes">
          <div className="row">
            <div className="col-md-6 col-xl-3 ">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h4 className="card-title mb-2 ">Total Incomes</h4>
                      <p className="text-muted fw-medium fs-22 mb-0">$12,7812.09</p>
                    </div>
                    <div>
                      <div className="avatar-md bg-primary bg-opacity-10 rounded">
                        <Icon icon="solar:wallet-money-broken" className="fs-32 text-primary avatar-title"></Icon>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mt-3">
                    <p className="mb-0">
                      <span className="text-success fw-medium mb-0">
                        <i className="ri-arrow-up-line"></i>34.4%
                      </span>{" "}
                      vs last month
                    </p>
                    <div>
                      <a href="#!" className="link-primary fw-medium">
                        See Details <i className="ri-arrow-right-line align-middle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-3">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h4 className="card-title mb-2 ">Total Properties</h4>
                      <p className="text-muted fw-medium fs-22 mb-0">{properties.pagination !== undefined ? properties.pagination.total : 0} Unit</p>
                    </div>
                    <div>
                      <div className="avatar-md bg-primary bg-opacity-10 rounded">
                        <Icon icon="solar:home-broken" className="fs-32 text-primary avatar-title"></Icon>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mt-3">
                    <p className="mb-0">
                      <span className="text-danger fw-medium mb-0">
                        <i className="ri-arrow-down-line"></i>8.5%
                      </span>{" "}
                      vs last month
                    </p>

                    <div>
                      <a href="#!" className="link-primary fw-medium">
                        See Details <i className="ri-arrow-right-line align-middle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-3">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h4 className="card-title mb-2 ">Unit Sold</h4>
                      <p className="text-muted fw-medium fs-22 mb-0">893 Unit</p>
                    </div>
                    <div>
                      <div className="avatar-md bg-primary bg-opacity-10 rounded">
                        <Icon icon="solar:dollar-broken" className="fs-32 text-primary avatar-title"></Icon>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mt-3">
                    <p className="mb-0">
                      <span className="text-success fw-medium mb-0">
                        <i className="ri-arrow-up-line"></i>17%
                      </span>{" "}
                      vs last month
                    </p>
                    <div>
                      <a href="#!" className="link-primary fw-medium">
                        See Details <i className="ri-arrow-right-line align-middle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-3">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h4 className="card-title mb-2 ">Unit Rent</h4>
                      <p className="text-muted fw-medium fs-22 mb-0">459 Unit</p>
                    </div>
                    <div>
                      <div className="avatar-md bg-primary bg-opacity-10 rounded">
                        <Icon icon="solar:key-minimalistic-square-broken" className="fs-32 text-primary avatar-title"></Icon>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mt-3">
                    <p className="mb-0">
                      <span className="text-danger fw-medium mb-0">
                        <i className="ri-arrow-down-line"></i>12%
                      </span>{" "}
                      vs last month
                    </p>
                    <div>
                      <a href="#!" className="link-primary fw-medium">
                        See Details <i className="ri-arrow-right-line align-middle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {propertyView === "List" && (
          <PropertyList
            properties={properties}
            isLoading={isLoading}
            filterGrid={filterGrid}
            onFilterSubmit={onFilterSubmit}
            filteredValues={filteredValues}
            propertyView={propertyView}
            setFilteredValues={setFilteredValues}
            fetchData={fetchData}
            selectedListings={selectedListings}
            onHandleselectedList={onHandleselectedList}
          />
        )}
        {propertyView === "Grid" && (
          <PropertyGrid properties={properties} isLoading={isLoading} filterGrid={filterGrid} onFilterSubmit={onFilterSubmit} filteredValues={filteredValues} propertyView={propertyView} />
        )}

        <AddLead selectedListings={selectedListings} />

        <CustomModal renderItem={renderItem} title="Add New Property" visible={pathname.toLowerCase().includes("new-property")} />

        <div className="pagination-grid">
          <Pagination total={properties.pagination !== undefined ? properties.pagination.total : 0} pageSize={paginationObj.pageSize} current={paginationObj.current} onChange={paginationChange} />
        </div>
      </div>
    </div>
  );
};

export default PropertyListing;
